import L from 'leaflet';

export const position = [50.3684,30.4569];

export const icon100pab = new L.Icon({
  iconUrl: './sw.png',
  iconSize: [18, 18],
  iconAnchor: [9, 9],
  popupAnchor: [0, -18],
});

export const icon3k = new L.Icon({
  iconUrl: './3k.png',
  iconSize: [30, 30],
  iconAnchor: [15, 15],
  popupAnchor: [0, -30],
});

export const icon30k = new L.Icon({
  iconUrl: './30k.png',
  iconSize: [40, 40],
  iconAnchor: [20, 20],
  popupAnchor: [0, -40],
});

export const icon100k = new L.Icon({
  iconUrl: './summit.png',
  iconSize: [40, 40],
  iconAnchor: [20, 20],
  popupAnchor: [0, -40],
});

export const iconKp = new L.Icon({
  iconUrl: './kp.png',
  iconSize: [20, 20],
  iconAnchor: [10, 10],
  popupAnchor: [0, -20],
});